<template>
  <gmap-map
    :center="center"
    :zoom="13"
    style="width: 100%; height: 250px"
  >
    <gmap-marker
      :position="markers"
      title="Dirección de envío"
      :clickable="true"
      :draggable="true"
      @click="center = center"
    ></gmap-marker>
  </gmap-map>
</template>

<script>

export default {
  props: ['center'],
  computed: {
    markers() {
      return {lat: this.center.lat, lng: this.center.lng}
    }
  }
}
</script>
